
(function () {
  'use strict';
  angular.module('finance.vckkcat')
    .component('kkcatsearch', {
      restrict: 'E',
      bindings: {
      kkcat: '<',
  kkcatref: '<',
    parentsave: '&?',
    editinplace: '@?',
    ti: '@?'
},
  template: `
        <div class="form-group">
          <div class="input-group">
                <input type="text" class="form-control" tabindex="{{vm.tabi}}"
                   ng-class="{'dirtyfield': vm.asyncSelected.length > 0}"
                   autofocus
                   placeholder="Kürzel"
                   ng-model="vm.asyncSelected"
                   typeahead-on-select="$parent.$dismiss();vm.showkkcat($item, $model, $label)"
                   uib-typeahead="kkcat as kkcat.text for kkcat in vm.getKkcats($viewValue)"
                   typeahead-loading="loadingNames"
                   typeahead-no-results="noResults">
            <span class="input-group-btn">
              <button type="submit"
                      ng-class="{'btn-warning': noResults, 'btn-info': !noResults}"
                      class="btn" tabindex="-1"><i class="fa fa-search"></i></button>
            </span>
          </div>
        </div>
        
        
        <i ng-show="loadingNames" class="fa fa-refresh"></i>
        <div ng-show="noResults">
          <i class="fa fa-remove"></i> Keine SV gefunden
          <span class="btn btn-success" ng-click="vm.addKkcat()" ng-hide="vm.error">Neue Sozialversicherung eingeben</span>
          <span ng-click="vm.addKkcat()" ng-show="vm.error"><i class="fa fa-warning text-danger"></i> Sozialversicherung konnte nicht angelegt werden!</span>
        </div>
        
        <div ng-show="vm.editinplace === true">
          <kkcateditor kkcat="vm.kkcat"></kkcateditor>
        </div>
        
        
      `,
    controllerAs: 'vm',
    controller: ['$log', 'Kkcat', 'KkcatHelper',
    function ($log, Kkcat, KkcatHelper) {
    let vm = this;
    vm.save = save;
    vm.showkkcat = showkkcat;
    
    vm.getKkcats = getKkcats;
    // vm.addKkcat = KkcatHelper.addKkcat;
    vm.addKkcat = addKkcat;
    vm.editKkcat = KkcatHelper.editKkcat;
    
    vm.$onInit = function () {
      vm.newkkcat = {};
      
      if (angular.isDefined(vm.editinplace) && vm.editinplace === 'true') {
        vm.editinplace = true;
      }
      
      $log.debug('debug - editinplace', vm.editinplace);
      
      
      if (angular.isUndefined(vm.ti))  {
        vm.ti = 0;
        vm.tabi = 0;
      }
      if (angular.isString(vm.ti)) {
        vm.tabi = parseInt(vm.ti, 10);
      }
      else {
        vm.tabi = 0;
      }
      vm.lastkkcat = angular.copy(vm.kkcatresult);
      vm.lastkkcatref = angular.copy(vm.kkcatref);
    };
    
    function addKkcat() {
      $log.debug('debug - kkcatsearch addKkcat called');
    KkcatHelper.addKkcat(function (kkcat) {
        $log.debug('debug: handle newly create kkcat');
        vm.kkcat = {};
        vm.kkcat.name = kkcat.name;
        vm.kkcat.short = kkcat.short;
        vm.kkcat._id = kkcat._id;
        vm.kkcatref = kkcat._id;
        vm.asyncSelected = kkcat.short;
        vm.parentsave({kkcat: vm.kkcat, kkcatref: vm.kkcatref});
      }, function (err) {
        vm.error = true;
        $log.error(err);
      });
    }
    
    
    // typeahead kkcat search backend query
    function getKkcats(val) {
      // return Kkcatahead.$search({query: val}).$asPromise().then(function (response) {
      return Kkcat.$searchahead({query: val}).$asPromise().then(function (response) {
        return response.map(function (kkcat) {
        kkcat.text = kkcat.short;
          delete vm.error;
          return kkcat;
        });
      });
    }
    
    // typeahead kkcat search action
    function showkkcat($item, $model, $label) {
      /* jshint unused:false */
      /* eslint "no-unused-lets": [2, {"args": "none"}] */
      vm.kkcat = $model;
      vm.kkcatref = $model._id;
      delete vm.asyncSelected;
      vm.editinplace = true;
      $log.debug('debug - vm.editinplace, vm.editinplace === true?: ', vm.editinplace, vm.editinplace === true);
      if (vm.editinplace === true) {
        vm.kkcat = $model;
        vm.kkcatref = $model._id;
        $log.debug('debug - kkcatsearch editinplace');
      }
      else {
        vm.kkcat = {};
        vm.kkcat.name = $model.name;
        vm.kkcat.short = $model.short;
        vm.kkcat._id = $model._id;
        vm.kkcatref = $model._id;
        vm.parentsave({kkcat: vm.kkcat, kkcatref: vm.kkcatref});
        $log.debug('debug - kkcatsearch do not  editinplace', vm.parentsave);
      }
    }
    
    function save() {
      if (!angular.equals(vm.kkcat, vm.lastkkcat) || !angular.equals(vm.kkcatref, vm.lastkkcatref) ) {
        vm.lastkkcat = angular.copy(vm.kkcat);
        vm.lastkkcatref = angular.copy(vm.kkcatref);
        vm.parentsave({kkcat: vm.kkcat, kkcatref: vm.kkcatref});
      }
    }
    
    
  }] // controller
}); // component

// klammerfriedhof
}());